import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'zui-user-metadata',
  templateUrl: './user-metadata.component.html',
  styleUrls: ['./user-metadata.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMetadataComponent implements OnInit {
  constructor(private auth: AuthService) {}

  displays = [];

  ngOnInit() {
    // this.auth.getAccessTokenSilently().subscribe(token => {
    //   const tokenWithoutBearer = {
    //     tokenStr: token
    //   };
    //   const tokenWithBearer = {
    //     tokenStr: `Bearer ${token}`
    //   };
    //   this.displays.push(tokenWithBearer);
    //   this.displays.push(tokenWithoutBearer);
    // });
  }

  copyText(tokenData) {
    const text = tokenData.tokenStr;
    navigator.clipboard
      .writeText(text)
      .then(() => {
        tokenData.isCopied = true;
        setTimeout(() => {
          tokenData.isCopied = false;
        }, 2000);
      })
      .catch(err => {
        console.error(err);
      });
  }
}
